import { useQuery } from '@tanstack/react-query';
import * as Routes from 'modules/routes';
import axios from 'axios';
import { LessonTagValues } from '../types';

type LessonTagValuesType = {
  programId: number,
  lessonId: number,
  tagId: number,
  isEnabled: boolean,
};

const useLessonTagValues = ({ programId, lessonId, tagId, isEnabled }: LessonTagValuesType) => {
  const path = Routes.plato_api_lesson_tag_values_tags_path({
    lesson_id: lessonId,
    program_id: programId,
    tag_id: tagId,
  });

  const query = useQuery(['lesson_tag_content', programId, lessonId, tagId], () => (
    axios
      .get<LessonTagValues>(path)
      .then(res => res.data)
      // eslint-disable-next-line no-console
      .catch(err => console.error(err))
  ), { enabled: isEnabled, staleTime: Infinity });

  return { ...query, data: query.data || {} as LessonTagValues };
};

export default useLessonTagValues;
